<template>
  <div id="PocPage">
    <section class="hero is-warning">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">W A R N I N G ! !</h1>
          <h2 class="subtitle is-5">
            U n d e r - C o n s t r u c t i o n - A r e a :)
          </h2>
        </div>
      </div>
    </section>
    <geo-search />
  </div>
</template>

<script>
import GeoSearch from "@/components/GeoSearch.vue";

export default {
  name: "PocPage",
  components: {
    GeoSearch
  },
  data() {
    return {
      labels: [
        "New Prospect",
        "Service Availability",
        "Calling",
        "Call Response",
        "Customer"
      ],
      subLabels: ["Old", "New"],
      values: [
        // with the given Labels and SubLabels here's what the values represent:
        //
        // Direct, Social, Ads
        //    |      |     |
        //    v      v     v
        [3000, 0], // Segments of "Impressions" from top to bottom
        [2000, 1000], // Segments of "Impressions" from top to bottom
        [500, 1500], // Segments of "Impressions" from top to bottom
        [300, 200], // Segments of "Impressions" from top to bottom
        [300, 0] // Segments of "Impressions" from top to bottom
      ],
      colors: [
        ["#23d160"],
        ["#ff0040"] // color set for "Impressions" segment
      ],
      direction: "horizontal",
      gradientDirection: "horizontal",
      height: 300,
      width: 800
    };
  }
};
</script>

<style scoped>
.center-content {
  text-align: center;
}
</style>
